import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Container } from 'semantic-ui-react';

import ResizableIframe from './ResizableIframe';

import { CmsPageLayout } from '../cms/CmsPage';
import { replaceValues } from '../utils/stringUtils';
import { useCurrentUser } from '../shared/store-user.hooks';

function IframePage(props) {
  const {
    url,
    hasAutoResize,
    header,
    metadata,
    pageId,
    design,
    pageHeader,
    pageFooter,
    ...iframe
  } = props;
  const user = useCurrentUser();

  if (!url) return null;
  const iframeUrl = replaceValues(url, { ...user, userId: user._id });
  return (
    <CmsPageLayout
      className={cx('page', 'page--iframe', pageId)}
      header={header}
      metadata={metadata}
      designOverride={design}
      pageHeader={pageHeader}
      pageFooter={pageFooter}
    >
      <Container>
        <ResizableIframe
          src={iframeUrl}
          autoResize={hasAutoResize}
          allowFullScreen
          allow="camera;microphone;fullscreen"
          {...iframe}
        />
      </Container>
    </CmsPageLayout>
  );
}

IframePage.defaultProps = {
  design: {},
  header: {},
  hasAutoResize: true,
  pageFooter: undefined,
  pageHeader: undefined,
  pageId: undefined,
  url: undefined,
};

IframePage.propTypes = {
  design: PropTypes.object,
  header: PropTypes.object,
  hasAutoResize: PropTypes.bool,
  pageFooter: PropTypes.object,
  pageHeader: PropTypes.object,
  pageId: PropTypes.string,
  url: PropTypes.string,
};

export default IframePage;
